import { useParams } from 'react-router-dom'
import { ConsoleLayout } from '../components/console/ConsoleLayout'
import { useTopicQuery } from '../hooks/queries'
import { useAuthStore } from '../store/auth'

export function ChatPage() {
  const { topicId } = useParams<{ topicId: string }>()
  const username = useAuthStore((s) => s.username)
  const { data: selectedTopic } = useTopicQuery(topicId)

  if (!topicId) return null

  return (
    <ConsoleLayout
      topicId={topicId}
      topicName={selectedTopic?.name}
      workspaceId={selectedTopic?.workspace_id}
      agents={selectedTopic?.agents ?? []}
      users={selectedTopic?.users ?? []}
      currentUser={username}
    />
  )
}
